/* eslint-disable react/prop-types */
import React from 'react'
import { Pressable, View, Image, StyleSheet } from 'react-native'
import confirm from '../../assets/sounds/confirm.mp4'
import { playSound } from '../../utils/AudioPlayer'

const CardInfo = (props) => {
  const handleOnPress = (ID) => {
    if (ID === '') return
    playSound(confirm)
    props.onOpen(ID)
  }

  return (
    <View style={[props.style, styles.container]}>
      <Pressable onPress={() => handleOnPress(props.card3ID)}>
        <Image style={[styles.card1infobtn, { pointerEvents: props.card3ID !== '' ? 'auto' : 'none', opacity: props.card3ID !== '' ? 1 : 0.5 }]} source={require('../../assets/symbols/Info_button.png')} />
      </Pressable>
      <Pressable onPress={() => handleOnPress(props.card2ID)}>
        <Image style={[styles.card2infobtn, { pointerEvents: props.card2ID !== '' ? 'auto' : 'none', opacity: props.card2ID !== '' ? 1 : 0.5 }]} source={require('../../assets/symbols/Info_button.png')} />
      </Pressable>
      <Pressable onPress={() => handleOnPress(props.card1ID)}>
        <Image style={[styles.card3infobtn, { pointerEvents: props.card1ID !== '' ? 'auto' : 'none', opacity: props.card1ID !== '' ? 1 : 0.5 }]} source={require('../../assets/symbols/Info_button.png')} />
      </Pressable>
    </View>
  )
}

const styles = StyleSheet.create({
  container: {
    draggable: 'false',
    userSelect: 'none'
  },
  card1infobtn: {
    position: 'absolute',
    left: 290,
    top: 490,
    width: 47,
    height: 42,
    zIndex: 0
  },
  card2infobtn: {
    position: 'absolute',
    left: 577,
    top: 190,
    width: 47,
    height: 42,
    zIndex: 0
  },
  card3infobtn: {
    position: 'absolute',
    left: 860,
    top: 490,
    width: 47,
    height: 42,
    zIndex: 0
  }
})

export default CardInfo
